import { inject, Injectable, PLATFORM_ID } from '@angular/core';
import { Router } from '@angular/router';
import { isPlatformBrowser } from '@angular/common';

@Injectable({
    providedIn: 'root'
})
export class GtmService {
    private router = inject(Router);
    private platformId = inject(PLATFORM_ID);

    public pushTag(tagsObject: { [key: string]: string }): void {
        if (isPlatformBrowser(this.platformId)) {
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            (<any>window).dataLayer.push(tagsObject);
        }
    }
}
